import { associateOpenPay, updateAssociation, deleteAssociation, getOpenpayCredentials, getWithOpenPay, getWithoutOpenPay } from '../../../../actions/OpenpayActions';
import { ASSOCIATEOPENPAY, UPDATEASSOCIATION, DELETEASSOCIATION, GET_ERRORS } from '../../../../actions/types';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import BootstrapTable from 'react-bootstrap-table-next';
import DialogTitle from '@material-ui/core/DialogTitle';
import docs from '../../../../config/docs';
import TextField from '@material-ui/core/TextField';
import LoadingOverlay from 'react-loading-overlay';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import OpenpayDetail from './OpenpayDetail';
import { Info } from '@material-ui/icons';
import React, { Component } from 'react';
import { IconButton } from 'material-ui';
import { connect } from 'react-redux';
import '../MainContent.scss';
import './Openpay.scss';

const URL = docs.docsOpenpay;

function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}


class Openpay extends Component {

	///---------------------------------------INIT-------------------------------------

	state = {
		centersWithOpenpay: [],
		activeLoader: true,
		showSnackBar: false,
		textSnackBar: '',
		severitySnackBar: 'success',
		showDeactivateDialog: false,
		selectedId: 0,
		page: 1,
		limit: 10,
		search: '',
		detailModalVisible: false,
		dataField: null
	}


	constructor(props) {
		super(props);

		this.onPressCancel = this.onPressCancel.bind(this);
		this.onPressDelete = this.onPressDelete.bind(this);
		this.onSearch = this.onSearch.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onPressSave = this.onPressSave.bind(this);
		this.openDetailModal = this.openDetailModal.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleCloseDeactivateDialog = this.handleCloseDeactivateDialog.bind(this);
	}

	componentDidMount() {
		this.props.getOpenpayCredentials();
		this.props.getWithOpenPay(this.state.search, this.state.limit, this.state.page);
		this.props.getWithoutOpenPay();
	}

	componentDidUpdate(prevProps) {

		if (this.state.centersWithOpenpay !== this.props.openpay.centersWithOpenpay) {
			this.setState({
				centersWithOpenpay: this.props.openpay.centersWithOpenpay,
				activeLoader: false
			})
		}

		else if ((this.props.actionType === ASSOCIATEOPENPAY && prevProps.actionType !== ASSOCIATEOPENPAY)
			|| (this.props.actionType === UPDATEASSOCIATION && prevProps.actionType !== UPDATEASSOCIATION)) {

			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Se ha guardado la información exitosamente.",
				severitySnackBar: 'success',
				search: '',
				page: 1
			}, () => {
				this.props.openpay.success = null;
				this.props.getWithoutOpenPay();
				this.props.getWithOpenPay(this.state.search, this.state.limit, this.state.page);
			})
		}
		else if (this.props.actionType === DELETEASSOCIATION && prevProps.actionType !== DELETEASSOCIATION) {
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Se han eliminado los accesos exitosamente.",
				severitySnackBar: 'success',
			}, () => {
				this.props.getWithoutOpenPay();
				this.props.getWithOpenPay(this.state.search, this.state.limit, this.state.page);
			});
		}
		else if (this.props.actionType === GET_ERRORS && prevProps.actionType !== GET_ERRORS) {
			this.setState({
				showSnackBar: true,
				textSnackBar: this.props.openpay.error,
				severitySnackBar: 'error',
			});
		}
	}

	///---------------------------------------EVENTS-------------------------------------

	handleClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}

		this.setState({
			showSnackBar: false
		})
	};

	handleCloseDeactivateDialog = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}

		this.setState({
			showDeactivateDialog: false
		})
	};

	redirectTo() {
		const newWindow = window.open(URL, '_blank', 'noopener,noreferrer')
		if (newWindow) newWindow.opener = null
	}

	openDetailModal(row) {
		this.setState({
			detailModalVisible: true,
			dataField: row ? row : null
		})
	}

	onPressCancel = () => {
		this.setState({
			detailModalVisible: false
		})
	}

	onPressSave(data) {
		this.setState({
			activeLoader: true,
			detailModalVisible: false,
			dataField: null
		})
		if (!data._id)
			this.props.associateOpenPay(data);
		else
			this.props.updateAssociation(data);
	}

	onPressDelete(id) {
		this.setState({
			showDeactivateDialog: true,
			selectedId: id,
			detailModalVisible: false,
			dataField: null
		})
	}

	onChange(e) {
		e.persist();
		this.setState({
			[e.target.name]: e.target.value
		})
	}

	onSearch() {
		this.setState({
			page: 1,
			activeLoader: true
		}, () => {
			this.props.getWithOpenPay(this.state.search, this.state.limit, this.state.page);
		})
	}

	handleDelete() {
		this.props.deleteAssociation(this.state.selectedId);
		this.setState({
			activeLoader: true,
			showDeactivateDialog: false,
		})
	}

	///---------------------------------------VIEW-------------------------------------
	renderTable() {
		const columns = [{
			dataField: 'centro',
			text: 'Clave de centro',
		},
		{
			dataField: 'nombre',
			text: 'Nombre',
		},
		{
			dataField: 'razon_social.razon_social',
			text: 'Razón social',
		},
		{
			dataField: 'innerBranchId',
			text: 'ID de sucursal',
		}
		];


		const total = (this.props.openpay.total / this.state.limit) || 0;

		const rowEvents = {
			onClick: (e, row, rowIndex) => {
				this.openDetailModal(row);
			}
		};

		return (
			<>

				<div>

					<BootstrapTable keyField='_id'
						key="8908290138209"
						striped
						hover
						condensed
						rowEvents={rowEvents}
						data={this.state.centersWithOpenpay}
						headerWrapperClasses="title-table"
						rowClasses="custom-row-table table-hover"
						columns={columns}
					/>

				</div>
				<div className="toolbar100 end">
					<button
						className={this.state.page !== 1 ? "modalButtonPager" : "modalButtonPager disabled"}
						onMouseDown={(e) => {
							e.preventDefault();
							this.setState({
								page: this.state.page - 1
							}, () => {
								this.props.getWithOpenPay(this.state.search, this.state.limit, this.state.page);
							})

						}}
						disabled={this.state.page === 1 ? true : false}
					>
						« Anterior
					</button>
					<button
						className={this.state.page < total ? "modalButtonPager" : "modalButtonPager disabled"}
						onMouseDown={(e) => {
							e.preventDefault();
							this.setState({
								page: this.state.page + 1
							}, () => {
								this.props.getWithOpenPay(this.state.search, this.state.limit, this.state.page);
							})
						}}
						disabled={this.state.page < total ? false : true}
					>
						Siguiente »
					</button>
				</div>

			</>
		);
	}

	render() {
		const { centersWithoutOpenpay, openpayCredentials } = this.props.openpay;
		return (
			<div className="main-content">
				<div className="malls-category-headers">
					Gestión de razones sociales para Openpay
					<IconButton
						size="small"
					>
						<Info onClick={() => this.redirectTo()} />
					</IconButton>
				</div>
				<div className="user-category-wrapper">
					<div className="toolbar100 space">
						<TextField
							style={{ height: "10%", width: "49.8%" }}
							id="input-search"
							label="Buscar. Ej.: Pachuca, F015, PHARMA AMIGO S.A. DE C.V."
							name="search"
							inputProps={{ style: { fontSize: "1rem" } }}
							InputLabelProps={{ style: { fontSize: "0.7rem" } }}
							onChange={this.onChange}
							value={this.state.search}
							size="medium"
						/>
						<button
							className="edit-buttonOK"
							onClick={this.onSearch}
							style={{ width: "10%", marginTop: "1%", marginLeft: "-15%" }}
						>
							Buscar
						</button>
						<button
							className="buttonAdd"
							onClick={this.openDetailModal}
						>
							Agregar
						</button>
					</div>
					{
						this.renderTable()
					}
				</div>
				{
					<LoadingOverlay
						active={this.state.activeLoader}
						isVisible={this.state.activeLoader}
						spinner
						text='Esto puede tardar unos minutos'
						styles={{
							wrapper: {
								width: this.state.activeLoader ? '100%' : '0%',
								height: this.state.activeLoader ? '100%' : '0%',
								overflow: 'hidden',
							},
							overlay: (base) => ({
								...base,
								background: 'rgba(10, 10, 10, 0.7)'
							})
						}}>
					</LoadingOverlay>
				}
				{
					<OpenpayDetail
						visible={this.state.detailModalVisible}
						centersWithoutOpenpay={centersWithoutOpenpay}
						openpayCredentials={openpayCredentials}
						dataField={this.state.dataField}
						onPressDelete={this.onPressDelete}
						onPressCancel={this.onPressCancel}
						onPressSave={this.onPressSave}
					/>
				}
				{
					<Dialog
						open={this.state.showDeactivateDialog}
						onClose={this.handleCloseDeactivateDialog}
						aria-labelledby="alert-dialog-title"
						aria-describedby="alert-dialog-description"
					>
						<DialogTitle id="alert-dialog-title">{"Eliminar accesos"}</DialogTitle>
						<DialogContent>
							<DialogContentText id="alert-dialog-description">
								¿Seguro que deseas eliminar esta los accesos a esta razón social?
							</DialogContentText>
						</DialogContent>
						<DialogActions>
							<Button onClick={this.handleCloseDeactivateDialog} color="secondary">
								Cancelar
							</Button>
							<Button onClick={this.handleDelete} color="primary" autoFocus>
								Desactivar
							</Button>
						</DialogActions>
					</Dialog>
				}
				{
					<Snackbar open={this.state.showSnackBar} autoHideDuration={6000} onClose={this.handleClose}>
						<Alert onClose={this.handleClose} severity={this.state.severitySnackBar}>
							{this.state.textSnackBar}
						</Alert>
					</Snackbar>
				}
			</div>
		)
	}
}

const mapStateToProps = state => ({
	openpay: state.openpay_reducer,
	actionType: state.openpay_reducer.actionType
});

export default connect(
	mapStateToProps,
	{
		associateOpenPay,
		updateAssociation,
		deleteAssociation,
		getOpenpayCredentials,
		getWithOpenPay,
		getWithoutOpenPay
	}
)(Openpay);